/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { Viewport } from 'react-leaflet';

import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import { GraphTitle } from 'common/modules/printing/styles/Graph';
import styled from 'styled-components';
import Antenna from 'statsradio/domain/Antenna';
import AntennaReach from 'statsradio/domain/AntennaReach';
import type { GeoMapTypes } from '../domain/DashboardData';
import GeolocationReach from '../domain/GeolocationReach';
import GeoMapByAntenna from '../components/geolocalisation/map/GeoMapByAntenna';
import GeoMapByRegion from '../components/geolocalisation/map/GeoMapByRegion';
import GeolocalisationAntennaReach from '../components/geolocalisation/GeolocalisationAntennaReach';

const SCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  flex-direction: column;
  padding: 5px;
  page-break-inside: avoid;
  justify-content: space-between;
`;

type Props = {
  geoMapData: {
    layout: any,
    antennas: Antenna[],
    antennaMapViewport: Viewport,
  },
  geoMapType: GeoMapTypes,
  geolocalisation: GeolocationReach[],
  antennaReach: AntennaReach,
  t: any,
};

const renderGeoMapByAntennas = (antennas, antennaReach, viewport) => {
  return (
    <React.Fragment>
      <GeoMapByAntenna antennas={antennas} viewport={viewport} />
      <GeolocalisationAntennaReach antennaReach={antennaReach} />
    </React.Fragment>
  );
};

const renderGeoMapByRegion = (geolocalisation, layout) => {
  return (<GeoMapByRegion geolocalisation={geolocalisation} layout={layout}
    zoomable
  />);
};

function GeolocalisationPrintingCard(props: Props) {
  const { geolocalisation, antennaReach, geoMapType, t } = props;
  const { layout, antennas, antennaMapViewport } = props.geoMapData;

  const showGeoMapByRegion = geoMapType === 'byRegion' && geolocalisation;
  const showGeoMapByAntenna = geoMapType === 'byAntennas' && antennas && antennaReach;

  return ((showGeoMapByRegion || showGeoMapByAntenna) ?
    <SCard>
      <GraphTitle>
        {t('geolocation')}
      </GraphTitle>
      { showGeoMapByRegion && renderGeoMapByRegion(geolocalisation, layout)}
      { showGeoMapByAntenna && renderGeoMapByAntennas(antennas, antennaReach, antennaMapViewport)}
    </SCard>
    : null
  );
}

export default translate()(GeolocalisationPrintingCard);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/GeolocalisationPrintingCard.js